import DOMPurify from 'dompurify';

const ALLOWED_TAGS = [
  'p', 'br', 'span', 'div', 'b', 'strong', 'i', 'em', 'u', 's', 'strike',
  'sup', 'sub', 'small', 'mark', 'blockquote', 'pre', 'code', 'hr',
  'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
  'ul', 'ol', 'li', 'dl', 'dt', 'dd',
  'table', 'thead', 'tbody', 'tfoot', 'tr', 'td', 'th', 'caption', 'colgroup', 'col',
  'a', 'img', 'figure', 'figcaption',
  'video', 'audio', 'source', 'track',
  'iframe',
  'section', 'article', 'header', 'footer', 'aside', 'nav',
];

const ALLOWED_ATTR = [
  'style', 'class', 'href', 'target', 'rel', 'data-page-link',
  'src', 'alt', 'title', 'width', 'height',
  'colspan', 'rowspan', 'border', 'cellpadding', 'cellspacing', 'scope',
  'start', 'type', 'dir',
  'controls', 'poster', 'allow', 'allowfullscreen', 'frameborder',
];

DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A' && node.getAttribute('target') === '_blank') {
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

export const sanitizeHtml = (html) => {
  if (!html) return html;
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOW_DATA_ATTR: true,
    FORBID_TAGS: ['script', 'style', 'object', 'embed', 'applet', 'form', 'input', 'textarea', 'button', 'select', 'base', 'meta', 'link', 'svg'],
    FORBID_ATTR: ['onerror', 'onclick', 'onload'],
  });
};

export default sanitizeHtml;
